import { action } from 'satcheljs';
import { ValidatedAttachmentType } from '../store/schema/ValidatedAttachmentType';

export const composeValidationFailedForMessage = action(
    'COMPOSE_VALIDATION_FAILED_FOR_MESSAGE',
    (composeId: string, forceSend: boolean, validatedAttachmentType: ValidatedAttachmentType) => ({
        composeId,
        forceSend,
        validatedAttachmentType,
    })
);

export const composeValidationFailedForMessageWithSharingIssueForceSend = action(
    'COMPOSE_VALIDATION_FAILED_FOR_MESSAGE_FORCE_SEND',
    (composeId: string, forceSend: boolean) => ({ composeId, forceSend })
);

export const composeValidationFailedForMessageWithSharingIssueTimeDialogOpen = action(
    'COMPOSE_VALIDATION_FAILED_FOR_MESSAGE_TIME_DIALOG_OPEN',
    (composeId: string, timeDialogOpen: number) => ({ composeId, timeDialogOpen })
);

export const messageSuccessfullySent = action('MESSAGE_SUCCESSFULLY_SENT', (composeId: string) => ({
    composeId,
}));
